import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ModalContainer from '../../components/ModalContainer.jsx';
import DataTable from '../../components/Table/DataTable.jsx';
import { getSingleOrderService } from '../../services/ordersServices.js';
import Status from './additionFields/Status.jsx';
import Alert from '../../utils/Alert.js';
import ServiceImage from '../ServicesPage/additionFields/ServiceImage.jsx';
import { Button } from '@mui/material';
import EmailAndPhone from '../Users/additionFields/EmailAndPhone.jsx';


const Services = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [orderCode, setOrderCode] = useState(null);

  const location = useLocation();

  const navigate = useNavigate();

  const servicesCols = [
    {
      field: "code",
      text: "کد سرویس"
    },
    {
      field: null,
      text: "ایمیل / شماره تلفن مشتری",
      element: (rowData) => <EmailAndPhone rowData={rowData.customer} />
    },
    {
      field: null,
      text: "تصویر سرویس",
      element: (rowData) => <ServiceImage rowData={rowData} scrollQuery="#service-modal" />
    },
    {
      field: null,
      text: "وضعیت",
      element: (rowData) => <Status rowData={rowData} />
    },
    {
      field: null,
      text: "جزئیات مشتری",
      element: (rowData) => {
        return (
          <Button variant="contained"
            onClick={() => navigate("/orders/services/user", {
              state: rowData
            })}
          >
            اطلاعات مشتری
          </Button>
        )
      }
    },
    {
      field: null,
      text: "جزئیات سرویس",
      element: (rowData) => {
        return (
          <Button variant="contained" color="success"
            onClick={() => navigate("/orders/services/service", {
              state: rowData
            })}
          >
            اطلاعات سرویس
          </Button>
        )
      }
    },
    {
      field: null,
      text: "صفحه سرویس",
      element: (rowData) => {
        return (
          <Button variant="contained" color="success"
            onClick={() => window.open(`http://app.wisercam.com/DetailOrder/${rowData.code}`)}
          >
            مشاهده
          </Button>
        )
      }
    }
  ];

  const handleGetServicesOfOrder = async (orderCode) => {
    try {
      setIsLoading(true);
      const response = await getSingleOrderService(orderCode);
      if (response.status === 200) {
        setServices(response.data.services);
      }
    } catch (error) {
      Alert(`خطا ${error.response?.status || ""}!`, "در دریافت سرویس‌ها مشکلی رخ داده است!\nلطفاً مجدداً امتحان کنید.", "error");
      return navigate(-1)
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (location.state) {
      setOrderCode(location.state.code);
      handleGetServicesOfOrder(location.state.code);
    } else {
      return navigate(-1);
    }
  }, []);

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={true}
      title="سرویس‌ها"
      id="service-modal"
    >
      <DataTable
        tableCols={servicesCols}
        tableData={services}
        itemsCount={10}
        title={`سرویس‌های سفارش "${orderCode || ""}"`}
        searchField="code"
        isLoading={isLoading}
      >
        <Outlet context={{
          setServices
        }} />
      </DataTable>
    </ModalContainer>
  );
}

export default Services;
